$(function() {
  const dropdownSelector = '.store-dropdown';
  const dropdownContentSelector = '.store-dropdown-content';
  const activeClass = 'active';

  // Show dropdown content on hover over dropdown or content
  $(dropdownSelector).hover(
    function () {
      // Show the dropdown content
      $(this).find(dropdownContentSelector).stop(true, true).slideDown();
    },
    function () {
      // Close the dropdown when leaving the dropdown area entirely
      $(this).find(dropdownContentSelector).stop(true, true).slideUp(function() {
        // Reset active class to the first anchor tag
        $(this).find('a').removeClass(activeClass);
        $(this).find('a').first().addClass(activeClass);
      });
    }
  );

  // Manage active class for anchor tags
  $(`${dropdownContentSelector} a`).hover(
    function () {
      // Add active class to the hovered anchor
      $(`${dropdownContentSelector} a`).removeClass(activeClass);
      $(this).addClass(activeClass);
    }
  );

  // Ensure first anchor tag has active class by default
  $(`${dropdownContentSelector} a`).first().addClass(activeClass);
});


// Similar product popup 

$('.new-toggle').on('click', function(e) {
  e.preventDefault();
  $('.modal').removeClass('is-visible');
  $('body').removeClass('modal-open');
});

// Product Tailor Made Options Popup

$('.prod-options').on('click', function(e) {
  e.preventDefault();
  $('.modal').toggleClass('is-visible');
  $('body').toggleClass('modal-open');
  $('header').toggleClass('tailor-modal-open');
});


// Image Accordion

$(document).ready(function() {
  $(".accordion-item").hover(
    function() {
      if (!$(this).hasClass("last")) {
        $(".accordion-item").removeClass("open");
        $(this).addClass("open");
      }
    }, 
    function() {
    }
  );
});

// Our journey and Milestones tab 

$(function(){
    $('.milestones-year .year').click(function(){
        $('.milestones-year .year.active').removeClass('active');
        $(this).addClass('active');
    });
});

$(function () {
    // Function to check and update active class based on visible .info-wrapper
    function updateActiveYear() {
        $('.milestones-info .info-wrapper').each(function () {
            var wrapperTop = $(this).offset().top;
            var wrapperBottom = wrapperTop + $(this).outerHeight();
            var scrollPosition = $(window).scrollTop();
            var windowHeight = $(window).height();

            // Check if the .info-wrapper is in the viewport
            if (scrollPosition + windowHeight / 2 > wrapperTop && scrollPosition + windowHeight / 2 < wrapperBottom) {
                var activeYear = $(this).attr('id'); // Get the id of the visible wrapper
                $('.milestones-year .year.active').removeClass('active');
                $('.milestones-year .year a[href="#' + activeYear + '"]').parent().addClass('active');
                return false; // Break the loop once the active year is found
            }
        });
    }

    // Trigger the function on scroll and on page load
    $(window).on('scroll', updateActiveYear);
    updateActiveYear(); // Initial check on page load
});


$(document).ready(function() {
  $('.tab.our-journey').hide();
  $('.tab.milestones').show();

  $('.tab-link').click(function() {

    $('.tab-link.active').removeClass('active');
    $(this).addClass('active');
    
    if ($(this).hasClass('our-journey')) {
      $('.tab.our-journey').show();
      $('.tab.milestones').hide();
    } else if ($(this).hasClass('milestones')) {
      $('.tab.milestones').show();
      $('.tab.our-journey').hide();
    }
  });
});

// Size Chart in and cm toggle

document.addEventListener('DOMContentLoaded', function() {
  const sizeOptions = document.querySelectorAll('.size-options li');
  const imgIn = document.querySelector('.img-in');
  const imgCm = document.querySelector('.img-cm');

  sizeOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Remove 'active' class from all size options
      sizeOptions.forEach(opt => opt.classList.remove('active'));

      // Add 'active' class to the clicked option
      this.classList.add('active');

      // Show or hide images based on the clicked option
      if (this.classList.contains('in')) {
        imgIn.style.display = 'block';
        imgCm.style.display = 'none';
      } else if (this.classList.contains('cm')) {
        imgIn.style.display = 'none';
        imgCm.style.display = 'block';
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  
  function updateVariantDisplayDesktop() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(productCard => {
      const selectedRadio = productCard.querySelector('.product-card__swatch-list input[type="radio"]:checked');
      
      if (selectedRadio) {
        const variantTitle = selectedRadio.getAttribute('data-var-title'); 
        const className = `color_${variantTitle}`; 
        const hideVarElements = productCard.querySelectorAll('.hide_size');
        hideVarElements.forEach(element => {
          element.style.display = 'none';
          element.classList.remove('var_selected');
        });
        const elementsToShow = productCard.querySelectorAll(`.hide_size.${className}`);
        elementsToShow.forEach(element => {
          element.style.display = 'inline-block'; 
        });
        const firstElement = elementsToShow[0];
        if (firstElement) {
          const dataVarId = firstElement.getAttribute('data-var-id');
          firstElement.classList.add('var_selected');
          const hiddenInput = productCard.querySelector('.dyn_variant_id');
          if (hiddenInput) {
            hiddenInput.value = dataVarId;
          }
        }
      }
    });
  }


  function updateVariantDisplayMobile() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(productCard => {
      const selectedRadio = productCard.querySelector('.product-card__swatch-list input[type="radio"]:checked');
      
      if (selectedRadio) {
        const variantTitle = selectedRadio.getAttribute('data-var-title'); 
        const className = `color_${variantTitle}`; 
        const hideVarElements = productCard.querySelectorAll('.hide_size_mobile');
        hideVarElements.forEach(element => {
          element.style.display = 'none';
          element.classList.remove('var_selected');
        });
        const elementsToShow = productCard.querySelectorAll(`.hide_size_mobile.${className}`);
        elementsToShow.forEach(element => {
          element.style.display = 'inline-block'; 
        });
        const firstElement = elementsToShow[0];
        if (firstElement) {
          const dataVarId = firstElement.getAttribute('data-var-id');
          firstElement.classList.add('var_selected');
          const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
          if (hiddenInput) {
            hiddenInput.value = dataVarId;
          }
        }
      }
    });
  }


  updateVariantDisplayDesktop();


  updateVariantDisplayMobile();

 
  const swatchListsDesktop = document.querySelectorAll('.product-card__swatch-list');
  swatchListsDesktop.forEach(swatchList => {
    swatchList.addEventListener('change', () => {
      updateVariantDisplayDesktop();
    });
  });


  const swatchListsMobile = document.querySelectorAll('.product-card__swatch-list');
  swatchListsMobile.forEach(swatchList => {
    swatchList.addEventListener('change', () => {
      updateVariantDisplayMobile();
    });
  });


const productCardsDesktop = document.querySelectorAll('.product-card');

productCardsDesktop.forEach(productCard => {
  const hideSizeElements = productCard.querySelectorAll('.hide_size');

  if (hideSizeElements.length > 0) {
    hideSizeElements.forEach(element => {
      element.addEventListener('click', (event) => {
        hideSizeElements.forEach(el => el.classList.remove('var_selected'));
        event.target.classList.add('var_selected');

        const dataVarId = event.target.getAttribute('data-var-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  } else {
    const radioButtons = productCard.querySelectorAll('.product-card__swatch-list input[type="radio"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', (event) => {
        const dataVarId = event.target.getAttribute('data-variant-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  }
});



const productCardsMobile = document.querySelectorAll('.product-card');

productCardsMobile.forEach(productCard => {
  const hideSizeElementsMobile = productCard.querySelectorAll('.hide_size_mobile');

  if (hideSizeElementsMobile.length > 0) {
    hideSizeElementsMobile.forEach(element => {
      element.addEventListener('click', (event) => {
        hideSizeElementsMobile.forEach(el => el.classList.remove('var_selected'));
        event.target.classList.add('var_selected');

        const dataVarId = event.target.getAttribute('data-var-id');
        const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  } else {
    const radioButtonsMobile = productCard.querySelectorAll('.product-card__swatch-list input[type="radio"]');
    radioButtonsMobile.forEach(radio => {
      radio.addEventListener('change', (event) => {
        const dataVarId = event.target.getAttribute('data-variant-id'); 
        const hiddenInput = productCard.querySelector('.dyn_variant_id_mobile');
        if (hiddenInput) {
          hiddenInput.value = dataVarId;
        }
      });
    });
  }
});

});